import { PermissionCheckService } from "@src/infrastructure/services/permission";
import { useAdminAuth } from "../auth/useAdminAuth";

export const useUserPermissions = () => {
  const { getUser } = useAdminAuth();
  const adminUser = getUser();

  const Permissions = adminUser?.adminPermissions ?? [];

  /**
   * Has any permission
   */
  const hasAnyPermission = (requiredPermissions: string[]) => {
    return new PermissionCheckService().hasAnyPermission(
      requiredPermissions,
      Permissions
    );
  };

  /**
   * Has all permissions
   */
  const hasAllPermissions = (requiredPermissions: string[]) => {
    return new PermissionCheckService().hasAllPermissions(
      requiredPermissions,
      Permissions
    );
  };

  return {
    Permissions,
    hasAnyPermission,
    hasAllPermissions,
  };
};
